export enum ProjectTabs {
  PROJECT = 'about-story',
  DONORS = 'donors',
  SUBPROJECT = 'subprojects',
  FAQS = 'faq',
  NEWS = 'news',
}
